module.exports = __webpack_public_path__ + "static/media/review-icon.e6a8d8b1.svg";